import '.bn{position:relative;}.ssr-plugin'
import '.t{width:100%;}.ssr-plugin'
import '.fx{min-height:200px;}.ssr-plugin'
import '.g{display:flex;}.ssr-plugin'
import '.h{flex-direction:column;}.ssr-plugin'
import '.i{justify-content:center;}.ssr-plugin'
import '.bs{align-items:flex-start;}.ssr-plugin'
import '.v{padding:2rem;}.ssr-plugin'
import '.cn{background:var(--shades-white);}.ssr-plugin'
import '.aa{overflow:hidden;}.ssr-plugin'
import '.a6{position:absolute;}.ssr-plugin'
import '.ig{top:50%;}.ssr-plugin'
import '.ih{right:1rem;}.ssr-plugin'
import '.ii{transform:translateY(-50%);}.ssr-plugin'
import '.ij{width:120px;}.ssr-plugin'
import '.ik{height:120px;}.ssr-plugin'
import '.il{z-index:0;}.ssr-plugin'
import '.b{align-items:center;}.ssr-plugin'
import '.hg{z-index:1;}.ssr-plugin'
import '.ap{gap:0.5rem;}.ssr-plugin'
import '.im{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="bn t fx g h i bs v cn aa"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="a6 ig ih ii ij ik il g b i"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="bn hg g h bs ap im"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--primary-blue)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--primary-blue)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
